import styled from 'styled-components';
import { AdPlacement, IAdSpacing } from './types';
import { media } from '@prisjakt/ui-base';

export interface IAdSkeleton {
  $placement: AdPlacement;
  $spacing: IAdSpacing | undefined;
}

export const AdLabel = styled.span.attrs(() => ({
  classNames: '.pj-ui-ad-container',
}))`
  position: absolute;
  z-index: 1;
  pointer-events: none;
  top: 0;
  left: 0;
  display: block;
  background-color: rgba(220, 220, 220, 0.8);
  color: ${props => props.theme.colors.base600};
  font-size: 11px;
  padding: 0 3px;
`;

export const AdContainerSkeleton = styled.div<IAdSkeleton>`
  margin-top: ${props => props.$spacing?.top ?? 0};
  margin-bottom: ${props => props.$spacing?.bottom ?? 0};
  min-height: ${props => {
    return getHeightFromPlacementMobile(props.$placement);
  }};

  ${media.mediumUp<IAdSkeleton>`min-height: ${props => {
    return getHeightFromPlacementDesktop(props.$placement);
  }};`};

  ${media.mediumDown`
    margin-top: 0px;
  `}
`;

function getHeightFromPlacementDesktop(
  placement: AdPlacement | undefined
): string {
  if (!placement) {
    return 'auto';
  }
  switch (placement) {
    case 'panorama_top':
    case 'panorama_extra':
    case 'panorama_extra_2':
      return '120px';
    case 'dubbelpanorama1':
    case 'dubbelpanorama2':
    case 'dubbelpanorama3':
    case 'mob-banner-ad-a':
    case 'mob-banner-ad-b':
    case 'skyscraper_1':
    case 'skyscraper_2':
    case 'skyscraper_3':
    case 'panorama_target':
    default:
      return 'auto';
  }
}

function getHeightFromPlacementMobile(
  placement: AdPlacement | undefined
): string {
  if (!placement) {
    return 'auto';
  }
  switch (placement) {
    case 'dubbelpanorama1':
    case 'dubbelpanorama2':
    case 'dubbelpanorama3':
      return '160px;';
    case 'panorama_top':
    case 'mob-banner-ad-a':
    case 'mob-banner-ad-b':
    case 'skyscraper_1':
    case 'skyscraper_2':
    case 'skyscraper_3':
    case 'panorama_target':
    case 'panorama_extra':
    case 'panorama_extra_2':
    default:
      return 'auto';
  }
}
